var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 mb-4"},[_vm._v("Gestion des utilisateurs")]),_c('users-metrics',{staticClass:"mb-4"}),_c('users-buttons'),_c('users-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }